export default __webpack_public_path__ + "static/media/notificationMenuIcon.a1df58dc.svg";